import React, { useEffect, useMemo } from "react"
import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader"
import { useLoader } from "react-three-fiber"
import { useControl } from "react-three-gui"
import { useThree } from "react-three-fiber"

const Gallery = (props) => {
  const { setLoaded } = props
  const gltf = useLoader(GLTFLoader, "Models/scene.gltf")
  const { camera } = useThree()

  const model = useMemo(() => gltf.scene, [gltf])

  useEffect(() => {
    if (model) {
      // console.log(gltf)
      gltf.materials.Material_2145968699.vertexColors = false
      gltf.materials.Material_2145968699.needsUpdate = true
      gltf.materials.material_2.vertexColors = false
      gltf.materials.material_2.needsUpdate = true
      gltf.materials.material_1.vertexColors = false
      gltf.materials.material_1.needsUpdate = true
      gltf.materials.material.vertexColors = false
      gltf.materials.material.needsUpdate = true
      // gltf.materials.Material_2145968699_3.map.matrixAutoUpdate = false
      // gltf.materials.Material_2145968699.map.matrixAutoUpdate = false
      // gltf.materials.Mate2.map.matrixAutoUpdate = false
      camera.updateProjectionMatrix()
      setLoaded(true)
    }
  }, [model])

  const x = useControl("x", {
    type: "number",
    value: -2.8,
    min: -10,
    max: 10,
  })

  const y = useControl("y", {
    type: "number",
    value: 0,
    min: -10,
    max: 10,
  })

  return (
    <group
      {...props}
      dispose={null}
      position={[x, -8, y]}
      scale={[0.035, 0.035, 0.035]}
    >
      <primitive object={model} dispose={null} />
    </group>
  )
}

export default Gallery
